import { each, filter, isEmpty, orderBy, random, remove, sumBy, toInteger } from 'lodash';
import { ActivityTypeEnum, DiscountTypeEnum, OffTypeEnum, ProductRelationEnum, UsePromoCodeStatusEnum } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
/**
 * 处理第N份N折
 * @param opt
 * @returns
 */
export default function calNthItemNDiscount(opt) {
    const { itemMap, enablePromoCodeActivity } = opt;
    let { usePromoCodeStatus, nthItemNDiscountActivitys } = opt;
    const theSameItemMap = {};
    if (!isEmpty(opt.theSameItemMap)) {
        each(opt.theSameItemMap, (theSameItem, key) => {
            each(theSameItem, (product) => {
                for (let i = 0; i < (product.cnt || 0); i++) {
                    if (!theSameItemMap[key]) {
                        theSameItemMap[key] = [];
                    }
                    theSameItemMap[key].push(Object.assign(Object.assign({}, product), { cnt: 1, off: product.off / ((product === null || product === void 0 ? void 0 : product.cnt) || 1) }));
                }
            });
        });
        nthItemNDiscountActivitys = orderBy(nthItemNDiscountActivitys, ['extra.discountItemIndex'], ['asc']);
        each(nthItemNDiscountActivitys, (activity) => {
            var _a;
            if (activity.promoCode && usePromoCodeStatus === UsePromoCodeStatusEnum.Unused) {
                usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
            }
            const discountItemIndex = toInteger((_a = activity.extra) === null || _a === void 0 ? void 0 : _a.discountItemIndex) || 2;
            each(theSameItemMap, (scaleMap, scaleMapIndex) => {
                if (scaleMap.length >= discountItemIndex) {
                    const mapProduct = scaleMap[0];
                    let joinActitity = false;
                    if (activity.productRelation !== ProductRelationEnum.All) {
                        const findProduct = findActivityProduct(activity.productMap, mapProduct);
                        if (findProduct && activity.productRelation === ProductRelationEnum.Included) {
                            joinActitity = true;
                        }
                        else if (!findProduct && activity.productRelation === ProductRelationEnum.Excluded) {
                            joinActitity = true;
                        }
                    }
                    else {
                        joinActitity = true;
                    }
                    if (joinActitity) {
                        const joinNum = Math.floor(scaleMap.length / discountItemIndex);
                        for (let i = 0; i < joinNum; i++) {
                            const firstIdx = i * discountItemIndex + 0;
                            const lastIdx = firstIdx + discountItemIndex - 1;
                            const joinScale = scaleMap[lastIdx];
                            let productPrice = joinScale.price;
                            if (activity.isIncludeModifier) {
                                productPrice = joinScale.productAndModifierPrice;
                            }
                            let off = 0;
                            if (activity.discountType === DiscountTypeEnum.DiscountFee) {
                                off = activity.discountValue;
                            }
                            else if (activity.discountType === DiscountTypeEnum.DiscountRate) {
                                off = toFixed(productPrice * (1 - activity.discountValue));
                            }
                            if (off > productPrice) {
                                off = productPrice;
                            }
                            let beforeOff = 0;
                            for (let j = 0; j < discountItemIndex; j++) {
                                const scale = scaleMap[firstIdx + j];
                                beforeOff += scale.off;
                            }
                            if (beforeOff < off) {
                                const firstScale = scaleMap[firstIdx];
                                const key = [
                                    firstScale.productNo + '_' + firstScale.scaleNo,
                                    activity.activityId,
                                    random(1000, 9999),
                                ].join('_');
                                for (let j = 0; j < discountItemIndex; j++) {
                                    const scale = scaleMap[firstIdx + j];
                                    const itemId = scale.pk || scale.productNo + '_' + scale.scaleNo;
                                    removeNotNthItem(itemMap, itemId, scale.key);
                                    if (!itemMap[itemId]) {
                                        itemMap[itemId] = {
                                            items: [],
                                            itemAllOff: 0,
                                        };
                                    }
                                    let scaleOff = 0;
                                    if (firstIdx + j === lastIdx) {
                                        scaleOff = off;
                                    }
                                    theSameItemMap[scaleMapIndex][firstIdx + j].key = key;
                                    theSameItemMap[scaleMapIndex][firstIdx + j].off = scaleOff;
                                    itemMap[itemId].items.push(Object.assign(Object.assign({}, scale), { key: key, off: scaleOff, offId: activity.activityId, offTip: activity.activityName, offType: activity.promoCode ? OffTypeEnum.PromoCode : OffTypeEnum.Activity, activity: activity, cnt: 1, isIncludeModifier: activity.isIncludeModifier || false }));
                                }
                            }
                        }
                        if (activity.promoCode) {
                            if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                                usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                            }
                            enablePromoCodeActivity.push(activity.activityId);
                        }
                        theSameItemMap[scaleMapIndex] = filter(scaleMap, (theSame) => !theSame.key);
                        if (theSameItemMap[scaleMapIndex].length <= 0) {
                            delete theSameItemMap[scaleMapIndex];
                        }
                    }
                }
            });
        });
    }
    let productAllOff = 0;
    each(itemMap, (item) => {
        item.itemAllOff = toFixed(sumBy(item.items, 'off'));
        productAllOff += item.itemAllOff;
    });
    return { productAllOff: toFixed(productAllOff), usePromoCodeStatus };
}
/**
 * 删除不是第几个打折的商品
 * @param itemMap
 * @param id
 */
const removeNotNthItem = (itemMap = {}, id, key = '') => {
    if (itemMap[id]) {
        if (key) {
            remove(itemMap[id].items, (item) => {
                return item.key === key;
            });
            return;
        }
        each(itemMap[id].items, (item, index) => {
            if (item && item.offType !== OffTypeEnum.Coupon && item.offType !== OffTypeEnum.Plan) {
                if (!item.activity ||
                    (item.activity &&
                        item.activity.type !== ActivityTypeEnum.NthItemNDiscount &&
                        item.activity.type !== ActivityTypeEnum.FullItemNFree &&
                        item.activity.type !== ActivityTypeEnum.GroupBuy)) {
                    const itemCnt = item.cnt || 1;
                    item.off = toFixed((item.off / itemCnt) * (itemCnt - 1));
                    item.cnt = itemCnt - 1;
                    if (item.cnt <= 0) {
                        remove(itemMap[id].items, (item, idx) => {
                            return index === idx;
                        });
                    }
                    return;
                }
            }
        });
    }
};
//# sourceMappingURL=calNthItemNDiscount.js.map